import { ExpensesService } from "../services";

const extractBuildingId = (params) => {
  if (!params) return undefined;
  if (typeof params === "number") return params;
  if (typeof params === "object") {
    if (typeof params.buildingId === "number") return params.buildingId;
    if (typeof params.buildingId === "object") return params.buildingId?.id;
    if (typeof params.building === "number") return params.building;
    if (typeof params.building === "object") return params.building?.id;
    if (typeof params.id === "number") return params.id;
  }
  return undefined;
};

export const expense = {
  state: () => ({
    expenses: [],
    selectedExpenses: [],
    current: null,
  }),
  mutations: {
    setExpenses: (state, value) => (state.expenses = value || []),
    setSelectedExpenses: (state, value) => (state.selectedExpenses = value || []),
    setCurrentExpense: (state, value) => (state.current = value || null),
  },
  actions: {
    EXPENSE_FIND_ALL: async ({ commit }, params) => {
      const response = await ExpensesService.findAll(params || {});
      if (response.ok) {
        commit("setExpenses", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener los egresos");
      }
      return response;
    },
    EXPENSE_FIND_ONE: async ({ commit }, id) => {
      const response = await ExpensesService.findById(id);
      if (response.ok) {
        commit("setCurrentExpense", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener el egreso");
      }
      return response;
    },
    EXPENSE_CREATE: async ({ dispatch }, payload) => {
      const response = await ExpensesService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("EXPENSE_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    EXPENSE_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await ExpensesService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("EXPENSE_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    EXPENSE_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await ExpensesService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("EXPENSE_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    EXPENSE_DOWNLOAD_EXCEL: async (_, params) => ExpensesService.exportExcel(params),
    EXPENSE_DOWNLOAD_PDF: async (_, params) => ExpensesService.exportPdf(params),
  },
  getters: {
    expenseById: (state) => (id) => state.expenses.find((item) => item.id === id) || null,
  },
};

